import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "container-login100 flex-column" };
const _hoisted_2 = { class: "simple-screen-wrapper container container-fluid p-0 m-0" };
const _hoisted_3 = { class: "simple-screen" };
const _hoisted_4 = {
    class: "row h-100 ms-0 me-0",
    style: { "overflow": "hidden" }
};
const _hoisted_5 = { class: "col-lg-6 d-md-none d-lg-block p-2" };
const _hoisted_6 = { class: "col-lg-6 col-12 simple-screen__content" };
const _hoisted_7 = { class: "footer-bar mt-1 mb-1 d-flex justify-content-center justify-content-lg-end" };
const _hoisted_8 = {
    key: 0,
    class: "navbar-nav"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                            class: "simple-screen__image",
                            style: _normalizeStyle(_ctx.getImageStyles)
                        }, null, 4)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_7, [
                (_ctx.footerMenuEntriesRight.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerMenuEntriesRight, (menuItem) => {
                            return (_openBlock(), _createElementBlock("li", null, [
                                _createVNode(_component_g_link, {
                                    src: menuItem.actionCommand,
                                    target: menuItem.actionTarget,
                                    class: _normalizeClass(['nav-link', menuItem.cssClasses])
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(menuItem.caption), 1)
                                    ]),
                                    _: 2
                                }, 1032, ["src", "target", "class"])
                            ]));
                        }), 256))
                    ]))
                    : _createCommentVNode("", true)
            ])
        ])
    ]));
}
